import React from 'react';
import { TopBar } from './TopBar';
import { Logo } from './Logo';
import { DesktopMenu } from './DesktopMenu';
import { MobileMenu } from './MobileMenu';
import { PhoneButton } from './PhoneButton';
export function Header() {
  return <>
      <TopBar data-id="element-92" />
      <header className="sticky top-0 z-50" data-id="element-93">
        <div className="bg-header border-b border-divider shadow-sm relative" data-id="element-94">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-95">
            <div className="flex items-center justify-between h-16" data-id="element-96">
              <Logo data-id="element-97" />
              <DesktopMenu data-id="element-98" />
              <PhoneButton data-id="element-99" />
              <MobileMenu data-id="element-100" />
            </div>
          </div>
        </div>
      </header>
    </>;
}